module.exports = __webpack_public_path__ + "static/media/Hair_3.0e400ccf.jpg";